import React, { useEffect } from "react";
import Dashboard from "../../Dashboard";
import AddressManagement from "../../../../features/userDashboard/address/AddressManagement";

const AddressManagementPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Dashboard
      title="Address Management"
      description="Manage your delivery addresses"
    >
      <AddressManagement />
    </Dashboard>
  );
};

export default AddressManagementPage;
